<template>
    <button class="osm-button" @click="$emit('click')"><slot /></button>
</template>

<script>
export default {
    props: ['icon'],
};
</script>

<style lang="scss">
button.osm-button {
    border-radius: 21px;
    border: 1px solid #6c3e91;
    color: #6c3e91;
    // font-family: "Avenir Next";
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    padding: 9px 20px;
    transition: all 0.25s ease-in-out;

    &:focus {
        outline: none;
        background-color: #6c3e91;
        color: white;
    }

    &:not(:first-child) {
        margin-left: 10px;
    }
}

button.default {
    background-color: #6c3e91;
    color: white;

    &:focus {
        outline: none;
        background-color: #4f2571;
    }
}

button.stretch {
    width: 100%;
    max-width: 350px;
    //align-items:stretch;
    flex: 1;
}

button.green-theme {
    border: 1px solid #93c11f;
    color: #93c11f;

    &.default {
        background-color: #93c11f;
        color: white;
    }
}

button.red-theme {
    border: 1px solid #ea5b0c;
    color: #ea5b0c;

    &.default {
        background-color: #ea5b0c;
        color: white;
    }
}

button.blue-theme {
    border: 1px solid #6cd3fb;
    color: #6cd3fb;

    &.default {
        background-color: #6cd3fb;
        color: white;
    }
}
</style>
